import React, { useState, useEffect } from "react";
import "./sliderHome.css";

const buildYouTubeEmbedUrl = (id) =>
    `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&rel=0&showinfo=0&modestbranding=1&vq=hd1080`;

const SliderHome = ({ desktopVideoId, mobileVideoId }) => {
    const [videoUrl, setVideoUrl] = useState("");

    useEffect(() => {
        const handleResize = () => {
            const isMobile = window.innerWidth <= 767;
            const selectedId = isMobile ? mobileVideoId : desktopVideoId;
            setVideoUrl(buildYouTubeEmbedUrl(selectedId));
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [desktopVideoId, mobileVideoId]);

    return (
        <section className="slider-home">
            <div className="media-container">
                <div className="overlay-dark"></div>
                {videoUrl && (
                    <iframe
                        className="gif-container"
                        src={videoUrl}
                        title="Video fondo"
                        frameBorder="0"
                        allow="autoplay"
                    ></iframe>
                )}
            </div>
            <div className="overlay overlay-bg">
                <a className="btn-contactanos" href="#footer-quality-seal">CONTÁCTANOS</a>
            </div>
        </section>
    );
};

export default SliderHome;
